import { Reveal } from "@/components/site/motion";
import { ShieldCheck, UploadCloud, Sparkles } from "lucide-react";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-28 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid items-center gap-16 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">About OpenDegree</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display font-extrabold tracking-tighter text-ink text-4xl sm:text-5xl leading-[0.98]">
              One Profile.<br />Multiple Opportunities.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 max-w-xl text-lg leading-relaxed text-slatey">
              Learners complete one secure profile, upload their documents once, and OpenDegree intelligently matches
              them with suitable education providers based on their qualifications, preferences and eligibility.
            </p>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-slatey/90">
              The platform is designed to simplify admissions through automation while keeping students informed
              throughout their application journey.
            </p>
          </Reveal>

          <div className="mt-9 grid gap-4 sm:grid-cols-3">
            {[
              { icon: ShieldCheck, label: "One secure profile" },
              { icon: UploadCloud, label: "Upload documents once" },
              { icon: Sparkles, label: "Intelligent matching" },
            ].map((f, i) => (
              <Reveal key={i} delay={0.15 + i * 0.08} className="rounded-2xl border border-slate-200 bg-white p-4">
                <f.icon className="h-5 w-5 text-cobalt" />
                <p className="mt-3 text-sm font-semibold text-ink leading-snug">{f.label}</p>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Clipped editorial image with spotlight */}
        <Reveal delay={0.1} className="relative">
          <div className="relative overflow-hidden rounded-[28px] border border-slate-200 shadow-[0_30px_80px_rgba(10,37,64,0.12)]">
            <img
              src="https://images.unsplash.com/photo-1514369118554-e20d93546b30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
              alt="Student studying"
              className="h-[440px] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/50 via-transparent to-transparent" />
            <div className="absolute left-6 bottom-6 right-6 rounded-2xl border border-white/20 bg-white/10 p-4 backdrop-blur-md">
              <p className="text-sm font-semibold text-white">Discover. Apply. Track.</p>
              <p className="text-xs text-white/80 mt-1">A single streamlined admissions journey.</p>
            </div>
          </div>
          <div className="absolute -right-5 -top-5 h-20 w-20 rounded-full bg-cobalt/20 blur-2xl" />
        </Reveal>
      </div>
    </div>
  </section>
);
